import { render, staticRenderFns } from "./OperatingRegions.vue?vue&type=template&id=0cf8b74a&scoped=true&"
import script from "./OperatingRegions.vue?vue&type=script&lang=js&"
export * from "./OperatingRegions.vue?vue&type=script&lang=js&"
import style0 from "./OperatingRegions.vue?vue&type=style&index=0&id=0cf8b74a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf8b74a",
  null
  
)

export default component.exports